import * as React from 'react';
import {Component} from 'react';
import {observable, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import withClickOutside from 'react-onclickoutside';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {Button} from '../../../components/Common/Buttons/Button';
import keyCodes from '../../../constants/KeyCodes';
import {textConst, getLocalizedText, texts} from '../../../constants/TextConst';
@observer
class Input extends Component<any, any> {
    @observable title;
    input: HTMLInputElement;

    constructor(props) {
        super(props);
        makeObservable(this);
        this.title = this.props.title ? this.props.title : '';
        this.handleNameChange = this.handleNameChange.bind(this);
        this.approveNameChange = this.approveNameChange.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.returnFocus = this.returnFocus.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        this.input.focus();
    }

    onInputFocus = () => {
        this.input.addEventListener('keydown', this.handleKeyDown, true);
    };

    onInputBlur = () => {
        this.input.removeEventListener('keydown', this.handleKeyDown, true);
    };

    handleKeyDown(e: KeyboardEvent) {
        e.stopPropagation();
        if (e.keyCode === keyCodes.ENTER) {
            e.preventDefault();
            this.props.saveOnBlur ? this.handleClickOutside() : this.approveNameChange(e);
        } else if (e.keyCode === keyCodes.ESC) {
            this.title = this.props.title;
            this.handleClickOutside();
        }
    }

    handleNameChange(e) {
        this.title = this.props.maxLength
            ? e.target.value.substring(0, this.props.maxLength)
            : e.target.value;
    }

    approveNameChange(e) {
        this.props.onApprove(this.title);
    }

    handleClickOutside() {
        this.props.onApprove(this.title, this.returnFocus);
    }

    returnFocus() {
        this.input && this.input.focus();
    }

    handleClose(e) {
        e.preventDefault();
        this.props.handleClose();
    }

    render() {
        const {style, saveOnBlur} = this.props;

        return (
            <div className={'approved-input ' + style}>
                <input
                    type="text"
                    ref={i => (this.input = i)}
                    value={this.title}
                    onChange={this.handleNameChange}
                    onFocus={this.onInputFocus}
                    onBlur={this.onInputBlur}
                />
                {saveOnBlur ? (
                    <Icon
                        icon={PriorityIcon.x}
                        hoverable
                        skin="primary"
                        onClick={this.handleClose}
                    />
                ) : (
                    <Button
                        componentClasses="approve-btn"
                        text={getLocalizedText(texts.ok)}
                        alt={textConst.approveAlt}
                        onClick={this.approveNameChange}
                    />
                )}
            </div>
        );
    }
}

const BlurApprovedInput = withClickOutside(Input);

const ApprovedInput = ({saveOnBlur = false, ...props}) => {
    return saveOnBlur ? <BlurApprovedInput saveOnBlur {...props} /> : <Input {...props} />;
};

export default ApprovedInput;
